/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { getFieldZoneLayout } from "cms/fields/field-utils";
import { HeadingFieldDisplay } from "./display";
import { HeadingFieldEdit } from "./edit";

const HeadingField = (props) => {

    const zoneProps = {
        ...props,
        displayComponent: <HeadingFieldDisplay />,
        editComponent: <HeadingFieldEdit />,
    };
    return getFieldZoneLayout(zoneProps);
};
HeadingField.dissplayName = "HeadingField";
export { HeadingField };
